import { Injectable } from '@angular/core';
import { IProductionVersionDetailLayout } from '../../models/layout/production-version-detail-layout.model';
import { IProductionVersionLayout } from '../../models/layout/production-version-layout.model';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class ProductionVersionLayoutService {

    constructor(protected mySharedDataFacade: SharedDataFacade) {
    }

    public getProductionVersionLayout(): IProductionVersionLayout {
        return {
            columns: [ 'articleNr', 'costUnitId', 'incomingRecipeNr', 'outgoingRecipeNr', 'version', 'workingPlanNr' ],
        };
    }

    public getProductionVersionDetailLayout(): IProductionVersionDetailLayout {
        return {
            recipeTableColumns: [ 'articleNr', 'name', 'amount', 'measureUnit', 'validFrom', 'validTo', 'type' ]
        };
    }
}
